<template>
  <MembershipsSold v-if="!showTabs && initialData" v-bind="initialData" />

  <Page v-else-if="initialData" title="Memberships">
    <TabSwitcher id="memberships" :tabs="tabs" />
  </Page>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from "vue";
import { useFeatureFlag } from "@/lib/useFeatureFlag";

import Page from "@/components/Page.vue";
import TabSwitcher from "@/components/TabSwitcher/TabSwitcher.vue";
import MembershipsSold from "@/Reports/MembershipsSold.vue";
import PaymentActivity from "@/Reports/PaymentActivity.vue";

const showTabs = useFeatureFlag("membership_tabs_enabled");

const initialData = ref<{
  filters: [];
  source: string;
} | null>(null);

const failedPaymentsData = ref<{
  filters: [];
  source: string;
  failed_payments_count?: number;
} | null>(null);

const tabs = computed(() => [
  {
    name: "Membership To-Do",
    component: MembershipsSold,
    props: initialData.value
  },
  {
    name: "Payment Activity",
    component: PaymentActivity,
    props: {
      source: failedPaymentsData.value?.source || "",
      filters: failedPaymentsData.value?.filters || []
    },
    badge: failedPaymentsData.value?.failed_payments_count ?? null
  }
]);

const baseUrl = `${window.location.origin}${window.location.pathname}`;

onMounted(async () => {
  const [todoRes, failedRes] = await Promise.all([
    fetch(`${baseUrl}/initial_page_data`, { method: "GET" }),
    fetch(`${baseUrl}/failed_payments_initial_page_data`, { method: "GET" })
  ]);
  initialData.value = await todoRes.json();
  failedPaymentsData.value = await failedRes.json();
});
</script>
